import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})

export class NotificationsComponent implements OnInit {

  public notifications = new Array();
  

  constructor() {
    // This is intentional
  }

  ngOnInit() {

    this.notifications.push({
      href: "#",
      type: "Fuente",
      title: "%ZONE%",
      text: "El nombre de la geocerca por la cual se ha activado la notificación (para las notificaciones de geocerca). En el texto de las notificaciones del tipo Fuera de geocerca en la etiqueta %ZONE% se escriben separados por comas los nombres de las geocercas en que estaba la unidad en el momento de recibirse el último mensaje y de que ya ha salido. Si no se ha encontrado último mensaje de posición o no hay geocercas que satisfagan el criterio arriba mencionado, en el texto de la notificación solo se muestra el nombre de la etiqueta (%ZONE%).",
      date: "01/05/2020 9:55 am"
    });
    this.notifications.push({
      href: "#",
      type: "Sistema",
      title: "%CUSTOM_FIELD(*)%",
      text: "El valor del campo personalizado de las propiedades de la unidad. Si deja el asterisco entre paréntesis, se mostrarán todos los campos personalizados disponibles (incluidos los campos administrativos) y junto con los nombres de estos campos se escribirán sus valores. Para recibir el valor del campo concreto, hay que indicar su nombre entre paréntesis (tiene que corresponder completamente). En este caso en la notificación se mostrará solo el valor del campo (sin su nombre).",
      date: "12/04/2020 - 01:31 pm"
    });
    this.notifications.push({
      href: "#",
      type: "Fuente",
      title: "%ZONE_DESC%",
      text: "La descripción de la geocerca por la cual se ha activado la notificación (para la notificaciones de geocerca) tomado de sus propiedades.",
      date: "04/03/2020 - 11:32 am"
    });
    this.notifications.push({
      href: "#",
      type: "Fuente",
      title: "%TRIGGERED_SENSORS%",
      text: "Todos los sensores activados con sus valores (para controlar el valor del sensor en varias notificaciones).",
      date: "05/09/2020 - 6:15 am"
    });
    this.notifications.push({
      href: "#",
      type: "Sistema",
      title: "%LAT%",
      text: "La latitud en el momento de la notificación (por ejemplo, N 55° 45.7530').",
      date: "01/05/2020 - 9:27 am"
    });
    this.notifications.push({
      href: "#",
      type: "Fuente",
      title: "%HOUSE%",
      text: "Si los datos se desconocen, las etiquetas se muestran como son sin reemplazarse por valores reales. Las siguientes etiquetas son una excepción, ya que a falta de datos no aparecen en el texto de notificación: %UNIT%, %USER%, %CURR_TIME%, %LOCATION%, %LAST_LOCATION%, %SPEED%, %POS_TIME%, %MSG_TIME%, %UNIT_GROUP%, %ENGINE_HOURS%, %MILEAGE%, %LAT%, %LON%, %LATD%, %LOND%, %GOOGLE_LINK%, %INSURANCE_CASE%, %ZONES_ALL%, %ZONE_MIN%, %UNIT_ID%, %MSG_TIME_INT%, %NOTIFICATION%, %TAG_NAME%, %TAG_ID%, %LOSE_RESTORE%, %LOCATOR_LINK%.",
      date: "01/05/2020 - 9:55 am"
    });
  }

  /* showNotification(){
    return this.notifications;    
  } */
}
